import { ControlDocumentTransportOperator } from '../control-document-transport-operator';

export class ControlDocumentTransportOperatorBuilder {

  static fromJson(json): ControlDocumentTransportOperator {
    return (json) ? new ControlDocumentTransportOperator(
      json.defaultControlDocumentTransportOperator,
    ) : null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/control-document-transport-operator.builder.ts